export class PartnerLeadModel {
    email: string;
    mobile: string;
    firstName: string;
    lastName: string;
    partnerName: string;
    address: string;
    country: string;
    city: string;
    pinCode: string;
    panNumber: string;
    gstNumber: string;
    latitude: string;
    longitude: string;

    id: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/partner/PartnerLeadModel.ts